import "./styles.scss";
import { LocationsList } from "../../js/locations-list";

new LocationsList();
